<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <span class="card-title p-0 m-0">Invoices <button v-if="$hasPermission('manage_projects')" class="btn btn-sm btn-theme float-end" data-bs-toggle="modal" data-bs-target="#createInvoiceModal"><i class="bi bi-plus-circle pe-1"></i> Create Invoice</button></span>
                </div>
                <div class="card-body">
                    <Vue3EasyDataTable
                        ref="invoiceTable"
                        v-model:server-options="invoiceDataTable.serverOptions"
                        :headers="invoiceDataTable.headers"
                        :items="invoiceDataTable.items"
                        :loading="invoiceDataTable.loading"
                        :server-items-length="invoiceDataTable.totalItems"
                        :server-options="invoiceDataTable.serverOptions"
                        header-text-direction="center"
                        body-text-direction="center"
                        buttons-pagination
                        theme-color="#1d90ff"
                        table-class-name="hm-easy-table"
                        @update:server-options="getInvoices"
                    >
                        <template #item-total_amount="item">
                            {{ currency }}{{ parseFloat(item.total_amount).toFixed(2) }}
                        </template>
                        <template #item-created_at="item">
                            {{ dataTimeFormat(item.created_at, 'DD/MM/YYYY') }}
                        </template>
                        <template #item-status="item">
                            {{ item.status }}
                        </template>
                        <template #item-action="item">
                            <div class="d-flex align-items-center justify-content-center">
                                <EditButton
                                    :key="item.id"
                                    :itemId="item.id"
                                    :className="'me-2'"
                                    @editItem="handleEdit"
                                />
                                <DeleteButton
                                    :key="item.id"
                                    :itemId="item.id"
                                    @deleteItem="handleDelete"
                                />
                            </div>
                        </template>
                    </Vue3EasyDataTable>
                </div>
            </div>
        </div>
    </div>

    <!-- Create invoice modal -->
    <div class="modal fade" id="createInvoiceModal" aria-labelledby="createInvoiceModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <Form :validation-schema="invoiceSchema" v-slot="{ handleSubmit, errors }" as="div">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Invoice</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
                                <Field
                                    as="input"
                                    type="text"
                                    name="title"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`title`] }"
                                    placeholder="Enter title"
                                    v-model="invoice.title"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.title }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="description" class="form-label">Description</label>
                                <Field
                                    as="input"
                                    type="text"
                                    name="description"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`description`] }"
                                    placeholder="Enter description"
                                    v-model="invoice.description"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.description }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="amount" class="form-label">Amount <span class="text-danger">*</span></label>
                                <Field
                                    as="input"
                                    type="number"
                                    name="sub_total"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`sub_total`] }"
                                    placeholder="Enter amount"
                                    v-model="invoice.sub_total"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.sub_total }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="vat" class="form-label">VAT</label>
                                <Field
                                    name="vat"
                                    class="form-control bg-white"
                                    v-slot="{ field }"
                                >
                                    <VueSelect
                                        v-bind="field"
                                        :items="[{id:0, name:'0%'}, {id:20, name:'20%'}]"
                                        v-model="invoice.vat"
                                        :searchable="false"
                                        :clearable="false"
                                        :multiple="false"
                                        
                                    ></VueSelect>
                                </Field>
                                <div class="is-invalid invalid-feedback">{{ errors.vat }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="cis" class="form-label">CIS</label>
                                <Field
                                    as="input"
                                    type="number"
                                    name="cis"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`cis`] }"
                                    placeholder="Enter cis"
                                    v-model="invoice.cis"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.cis }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="retention" class="form-label">Retention</label>
                                <Field
                                    as="input"
                                    type="number"
                                    step="0.01"
                                    name="retention"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`retention`] }"
                                    placeholder="Enter retention"
                                    v-model="invoice.retention"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.retention }}</div>
                            </div>
                            <div class="col-md-6">
                                <label for="total" class="form-label">Total <span class="text-danger">*</span></label>
                                <Field
                                    as="input"
                                    type="number"
                                    name="total"
                                    class="form-control bg-white"
                                    :class="{ 'is-invalid': errors[`total`] }"
                                    readonly
                                    placeholder="Enter total"
                                    v-model="invoice.total_amount"
                                ></Field>
                                <div class="is-invalid invalid-feedback">{{ errors.total }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        <button
                            type="submit"
                            class="btn btn-theme"
                            v-text="isProcessing ? 'Processing...' : (invoice.mode == 'add' ? 'Add Invoice' : 'Update Invoice')"
                            :disabled="isProcessing"
                            :class="{'disabled': isProcessing}"
                            @click="handleSubmit($event, createInvoice)"
                        >
                        </button>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>
<script>
import { appMixin } from '../../mixin/appMixin';
import VueSelect from '../partials/VueSelect';
import EditButton from '../partials/EditButton';
import DeleteButton from '../partials/DeleteButton';

export default {
    name: 'ProjectInvoice',
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    components: {
        VueSelect,
        EditButton,
        DeleteButton
    },
    mixins: [appMixin],
    data() {
        return {
            isProcessing: false,
            invoice: {
                mode: 'add', // add or edit
                id: '',
                title: '',
                description: '',
                project_id: this.project.id,
                sub_total: '',
                vat: 20,
                vat_amount: '',
                cis: '',
                retention: '',
                discount: '',
                discount_amount: '',
                total_amount: 0,
                due_date: new Date(),
                paid_date: null,
                paid_amount: '',
                payment_method: 'cash',
                status: 'pending'
            },
            invoiceDataTable: {
                loading: true,
                totalItems: 0,
                serverOptions: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'created_at',
                    sortType: 'desc',
                },
                headers: [
                    {text: "Title", value: "title", sortable: true},
                    {text: "Description", value: "description", sortable: true},
                    {text: "Amount", value: "total_amount", sortable: true},
                    {text: "Created Date", value: "created_at", sortable: true},
                    {text: "Status", value: "status", sortable: true},
                    {text: "Action", value: "action", sortable: false},
                ],
                items: []
            }
        }
    },
    mounted() {
        this.getInvoices();

        // On clsoe modal set invoice to default
        $('#createInvoiceModal').on('hidden.bs.modal', () => {
            this.invoice = {
                mode: 'add',
                id: '',
                title: '',
                description: '',
                project_id: this.project.id,
                sub_total: '',
                vat: 20,
                vat_amount: '',
                cis: '',
                retention: '',
                discount: '',
                discount_amount: '',
                total_amount: 0,
                due_date: new Date(),
                paid_date: null,
                paid_amount: '',
                payment_method: 'cash',
                status: 'pending'
            };
        });
    },
    computed: {
        currency() {
            return this.$store.getters.getSystemSettings.currency.symbol || '£';
        },
        invoiceSchema() {
            return {
                title: 'required',
                sub_total: 'required|min:0',
            };
        },
        totalAmount() {
            const subTotal = parseFloat(this.invoice.sub_total) || 0;
            const vatAmount = subTotal * (parseFloat(this.invoice.vat) / 100) || 0;
            const cisAmount = parseFloat(this.invoice.cis) || 0;
            const retentionAmount = parseFloat(this.invoice.retention) || 0;
            const discountAmount = parseFloat(this.invoice.discount_amount) || 0;
            return ((subTotal + vatAmount + cisAmount) - retentionAmount) - discountAmount;
        }
    },
    methods: {
        async getInvoices() {
            this.invoiceDataTable.loading = true;
            let params = {
                page: this.invoiceDataTable.serverOptions.page,
                per_page: this.invoiceDataTable.serverOptions.rowsPerPage,
                sort_by: this.invoiceDataTable.serverOptions.sortBy,
                sort_type: this.invoiceDataTable.serverOptions.sortType,
                project_id: this.project.id
            };
            
            await axios.post('/admin/projects/get-invoices', params)
                .then(response => {
                    this.invoiceDataTable.items = response.data.items;
                    this.invoiceDataTable.totalItems = response.data.totalItems;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.invoiceDataTable.loading = false;
                });
        },
        showCreateInvoiceModal() {
            $('#createInvoiceModal').modal('show');
        },
        createInvoice() {
            let self = this;
            this.isProcessing = true;
            // Check if mode is add then create else edit
            if(this.invoice.mode == 'add') {
                axios.post('/admin/projects/create-invoice', this.invoice)
                    .then(function (response) {
                        self.getInvoices();
                        $('#createInvoiceModal').modal('hide');

                        // Show success message
                        self.$notification(response.data.status, response.data.message);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .finally(() => {
                        self.isProcessing = false;
                    });
            } else {
                axios.patch(`/admin/projects/update-invoice/${this.invoice.id}`, this.invoice)
                    .then(function (response) {
                        self.getInvoices();
                        $('#createInvoiceModal').modal('hide');

                        // Show success message
                        self.$notification(response.data.status, response.data.message);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .finally(() => {
                        self.isProcessing = false;
                    });
            }
        },
        handleEdit(id) {
            // find the item by id
            const item = this.invoiceDataTable.items.find(item => item.id === id);
            // Check if item is found
            if(item) {
                this.invoice = {
                    mode: 'edit',
                    id: item.id,
                    title: item.title,
                    description: item.description,
                    sub_total: item.sub_total,
                    vat: item.vat,
                    vat_amount: item.vat_amount,
                    cis: item.cis,
                    retention: item.retention,
                    discount: item.discount,
                    discount_amount: item.discount_amount,
                    total_amount: item.total_amount,
                    due_date: new Date(item.due_date),
                    paid_date: item.paid_date ? new Date(item.paid_date) : null,
                    paid_amount: item.paid_amount,
                    payment_method: item.payment_method,
                    status: item.status
                };
                $('#createInvoiceModal').modal('show');
            }
        },
        handleDelete(id) {
            // Find the item by id
            const item = this.invoiceDataTable.items.find(item => item.id === id);
            if(item) {
                // Display confirmation before delete
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#464f82',
                    confirmButtonText: 'Yes, delete it!',
                    reverseButtons: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.delete(`/admin/projects/delete-invoice/${id}`)
                            .then(response => {
                                this.getInvoices();
                                this.$notification(response.data.status, response.data.message);
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    }
                });
            }
        }
    },
    watch: {
        totalAmount(newTotal) {
            this.invoice.total_amount = newTotal;
        }
    }
}
</script>